// extracted by mini-css-extract-plugin
export var box = "_3v-0";
export var check = "_3v-1";
export var checkboxButton = "_3v-6";
export var checkboxGroup = "_3v-5";
export var disabled = "_3v-7";
export var ghost = "_3v-9";
export var input = "_3v-2";
export var label = "_3v-4";
export var normal = "_3v-8";
export var uncheck = "_3v-3";